import { render, staticRenderFns } from "./ChartLoader.vue?vue&type=template&id=158a9bec&scoped=true&"
import script from "./ChartLoader.vue?vue&type=script&lang=js&"
export * from "./ChartLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChartLoader.vue?vue&type=style&index=0&id=158a9bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a9bec",
  null
  
)

export default component.exports